import { Link } from 'react-router-dom';
import { EmptyState } from '../ui';

export function NotFound() {
  return (
    <div className="auth-wrap">
      <EmptyState
        title="404 — Page not found"
        description="That screen does not exist in the admin panel."
        action={<Link to="/">Back to dashboard</Link>}
      />
    </div>
  );
}
